import api from '@/api/stock/_stock.js'

export default {
    postVenteProduitsSoinsEffectues(data) {
        const promise = api().post('/vente', data)
        return promise.then((response) => response.data)
    },

    getVentesExterne(data) {
        const promise = api().get('/vente-externe', data)
        return promise.then((response) => response.data)
    },

    getMedicaments() {
        const promise = api().get('/ordonnance_medicaments')
        return promise.then((response) => response.data)
    },

    storeVente(data) {
        const promise = api().post(`/vente`, data)
        return promise.then((response) => response.data)
    },

    /**
     * Liste des articles 
     */
    allArticles() {
        const promise = api().get('/all_articles')
        return promise.then((response) => response.data)
    },

    getPrixBaseAssurance(data) {
        const promise = api().get('/medicaments/'+data.medicament_id+'/base_assurance/'+data.assurance+'/get_prix/'+data.groupe_actif_id+'/'+data.groupe_actif)
        return promise.then((response) => response.data)
    },

    getListeArticles() {
        const promise = api().get('/articles/liste')
        return promise.then((response) => response.data)
    },

    getListeMedicamentsParCategorie() {
        const promise = api().get('/medicaments/liste-ordonne')
        return promise.then((response) => response.data)
    },

    getListeConsommables() {
        const promise = api().get('/consommables/liste-all-consumable')
        return promise.then((response) => response.data)
    },
}